import { get } from './client';

// Themes
export const getThemes = () => get('/public/themes');
export const getThemeById = (id) => get(`/public/themes/${id}`);

// Products
export const getProducts = () => get('/public/products');
export const getProductsByTheme = (themeId) => get(`/public/products/theme/${themeId}`);
export const getProductById = (id) => get(`/public/products/${id}`);

// Fragrances
export const getFragrances = () => get('/public/fragrances');

// Testimonials
export const getTestimonials = () => get('/public/testimonials');

// Business Settings
export const getBusinessSettings = () => get('/public/business-settings');
